import React, { useMemo } from "react";
import { useIntl } from "react-intl";
import { describeVariant, variantSummary } from "../../utils/variantTitles";
import css from "./VariantTitles.module.css";
export var VariantTitlesCell = function (_a) {
    var variants = _a.variants;
    var formatMessage = useIntl().formatMessage;
    var list = useMemo(function () { return variants !== null && variants !== void 0 ? variants : []; }, [variants]);
    var summary = useMemo(function () { return variantSummary(list); }, [list]);
    var tooltip = useMemo(function () {
        return list.map(function (variant) { return describeVariant(variant, formatMessage); }).join("\n");
    }, [list, formatMessage]);
    if (!summary) {
        return null;
    }
    return (React.createElement("span", { title: tooltip, "data-testid": "variant-titles-cell" },
        summary.first,
        summary.more > 0 && (React.createElement("span", { className: css.moreCount }, " +".concat(summary.more)))));
};
